import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { ToastrService } from "ngx-toastr"
import { SharepointItem } from "src/app/sungeo/model/sharepoint-item"
import { environment } from '../../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class SharepointService {

  private baseUrl = '/sharepoint'

  constructor(private http: HttpClient) {}

  getChildren(driveId: string, itemId: string) {
    return this.http.get<SharepointItem[]>(
      `${environment.baseUrl}${this.baseUrl}/children`,
      { params: { driveId, itemId } }
    )
  }

  upload(dto: {
    driveId: string
    folderItemId: string
    urlDownloadSimu?: string
    simuFileName?: string
    screenshot?: File
    csvPresentation?: File
    csvDevis?: File
    csvVE?: File
  }) {
    const formData = new FormData()
    formData.append('driveId', dto.driveId)
    formData.append('folderItemId', dto.folderItemId)
    formData.append('urlDownloadSimu', dto.urlDownloadSimu)
    formData.append('simuFileName', dto.simuFileName)
    console.log('Uploading to Sharepoint with DTO:', dto)

    if (dto.screenshot) formData.append('screenshot', dto.screenshot)
    if (dto.csvPresentation) formData.append('csvPresentation', dto.csvPresentation)
    if (dto.csvDevis) formData.append('csvDevis', dto.csvDevis)
    if (dto.csvVE) formData.append('csvVE', dto.csvVE)

    return this.http.post(`${environment.baseUrl}${this.baseUrl}/save`, formData)
  }

  createFolder(driveId: string, parentItemId: string, folderName: string) {
    return this.http.post<any>(
      `${environment.baseUrl}${this.baseUrl}/folder`,
      null,
      {
        params: {
          driveId,
          parentItemId,
          folderName
        }
      }
    )
  }

}
